import React, { Component, Fragment } from "react";
import { MDBDataTableV5 } from "mdbreact";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Container,
  Button,
} from "reactstrap";

import swal from "sweetalert";
import {
  getLocations,
  locationAdd,
  locationEdit,
  locationDelete,
  model_open,
  model_close,
} from "../../../store/Masters/Locations/actions";

class Locations extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.getLocations();
  }

  handleDelete(values) {
    this.props.locationDelete(values, this.props.history);
  }

  deleteRecord = (record) => {
    swal({
      title: "Are you sure?",
      text:
        "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.handleDelete(record.id);
      } else {
        swal({ title: "Your imaginary file is safe!", timer: 1500 });
      }
    });
  };

  render() {
    var listdata = this.props.locationslist.map((row, order) => ({
      ...row,
      action: (
        <Fragment>
          <i
            className="mdi mdi-pencil-box-outline mr-2 font-size-18"
            style={{ cursor: "pointer", color: "#fc6f03" }}
            onClick={() => this.props.locationEdit(row)}
          ></i>
          <i
            className="mdi mdi-delete mr-2 font-size-18"
            style={{ cursor: "pointer", color: "#ff0000" }}
            onClick={() => this.deleteRecord(row)}
          ></i>
        </Fragment>
      ),
    }));

    const data = {
      columns: [
        {
          label: "Code",
          field: "code",
          sort: "disabled",
          width: 150,
        },
        {
          label: "Name",
          field: "name",
          sort: "asc",
          width: 800,
        },
        {
          label: "Actions",
          field: "action",
          key: "id",
          text: "Actions",
          width: 50,
        },
      ],
      rows: listdata,
    };

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <Card>
                  <CardHeader className="bg-transparent border-bottom">
                    <Link to="/MastersDashboard">
                      <i className="ri-arrow-go-back-fill font-size-18"></i>
                    </Link>
                    <h5 className="card-title-18 d-inline-block ml-2">
                      Location Master
                    </h5>

                    <div className="float-right">
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        onClick={() => this.props.model_open()}
                      >
                        Add Location
                      </Button>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <MDBDataTableV5
                      hover
                      striped
                      responsive
                      bordered
                      paging={true}
                      data={data}
                      searchTop
                      searchBottom={false}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { locationslist, model, rowdata } = state.Location;
  return { locationslist, model, rowdata };
};

export default connect(mapStatetoProps, {
  getLocations,
  locationAdd,
  locationEdit,
  locationDelete,
  model_open,
  model_close,
})(Locations);
